<div class="contract-wrapper">
  <!-- Logo Header -->
  <div class="contract-header">
    <img class="contract-logo" src="../../../assets/image/FordProtect_Blue_RGB_Hz_v1.png" 
      alt="Ford Protect">
  </div>

  <!-- Contract Title -->
  <h1 class="contract-title">TERMO DE CONTRATAÇÃO - SEGURO GARANTIA ESTENDIDA REDUZIDA</h1>

  <!-- Dados do Seguro Section -->
  <section class="contract-section">
    <h2 class="section-title">Dados do Seguro</h2>
    <div class="section-content">
      <p class="section-subtitle">
        Extensão de Garantia ({{paymentContractSummaryShort.distance}} km / {{paymentContractSummaryShort.extendedWarranty}} anos)
      </p>
      <p class="section-text">
        Início e término de vigência da cobertura: Conforme informação do bilhete de seguro a ser emitido. O bilhete somente será emitido, e enviado por e-mail automaticamente ao cliente, após a disponibilização do chassi do veículo.
      </p>
    </div>
  </section>

  <!-- Dados do Veículo Section -->
  <section class="contract-section">
    <h2 class="section-title">Dados do Veículo</h2>
    <div class="section-content">
      <div class="vehicle-info-row">
        <span class="vehicle-label">Modelo:</span>
        <span class="vehicle-value">{{ paymentContractSummaryShort.vehicleLine }}</span>
      </div>
      <div class="vehicle-info-row">
        <span class="vehicle-label">Ano:</span>
        <span class="vehicle-value">{{ paymentContractSummaryShort.modelYear }}</span>
      </div>
      <div class="vehicle-info-row">
        <span class="vehicle-label">Odômetro:</span>
        <span class="vehicle-value">{{ paymentContractSummaryShort.odometerStart }}</span>
      </div>
    </div>
  </section>

  <!-- Notas Section -->
  <section class="contract-section">
    <h2 class="section-title">Notas</h2>
    <div class="section-content notes-content">
      <p class="note-item">
        <strong>1)</strong> A contratação de seguro é opcional, sendo possível a desistência do contrato em até 7 (sete) dias corridos, com a devolução integral do valor pago, a contar da assinatura da proposta, no caso de contratação por bilhete individual, ou da emissão do bilhete, no caso de contratação por bilhete, ou do efetivo pagamento do prêmio, o que ocorrer por último. É proibido condicionar desconto no preço do bem à aquisição do seguro.
      </p>
      <p class="note-item">
        <strong>2)</strong> No caso de pagamento de prêmio fracionado, considera-se o pagamento da primeira parcela como o efetivo pagamento.
      </p>
    </div>
  </section>

  <!-- Segurador Info Section -->
  <section class="contract-section insurance-info">
    <div class="section-content">
      <p class="insurer-text">
        Garantido por AIG Seguros Brasil S/A. CNPJ 33.040.981/0001-50 | Central de Atendimento AIG 24 horas: 0800 726 6130 / Atendimento AIG a Deficientes Auditivos: 0800 724 0149 | Ouvidoria (2ª a 6ª-feira, das 9h às 18h): 0800 724 02 19 / Ouvidoria - Atendimento a Deficientes Auditivos e de fala (2ª a 6ª-feira, das 9h às 18h): 0800 200 1244. O registro deste plano na SUSEP não implica, por parte da Autarquia, incentivo ou recomendação a sua comercialização. Consulte sempre a versão das Condições Gerais do produto específico para informações completas. PROCESSO SUSEP – nº 15414.649128/2023-86.
      </p>
      <p class="insurer-text">
        Representante de Seguros: Ford Motor Company Brasil Ltda. CNPJ 03.470.727/0004-73.
      </p>
    </div>
  </section>

  <!-- Declaração do Segurado Section -->
  <section class="contract-section">
    <h2 class="section-title">Declaração do Segurado</h2>
    <div class="section-content">
      <p class="section-text">
        Confirmo que tomei ciência das Condições Gerais do produto e que recebi o caminho eletrônico que consta o documento que está disponibilizado digitalmente para consulta a qualquer momento (<a href="https://www.aig.com.br/condicoes-gerais" class="contract-link">https://www.aig.com.br/condicoes-gerais</a>) e, assim, autorizo a emissão do Bilhete de Seguro.
      </p>
    </div>
  </section>

  <!-- Pessoa Politicamente Exposta Section -->
  <section class="contract-section">
    <h2 class="section-title">Pessoa Politicamente Exposta</h2>
    <div class="section-content">
      <p class="section-text">
        Se na aceitação do risco for constatado que o segurado e/ou participante deste seguro está classificado como Pessoa Politicamente Exposta (conforme estabelecido na Circular SUSEP 612/2020), a seguradora reserva-se o direito de solicitar informações complementares em formulário padrão e documentos comprobatórios. Em casos específicos, a seguradora poderá solicitar documentação adicional sobre os principais administradores e procuradores da companhia a fim de garantir o devido cumprimento da referida circular.
      </p>
      <ol class="regulation-list">
        <li>Circular SUSEP 612/2020 - Art. 4º Para fins desta Circular, consideram-se expostas politicamente as pessoas naturais que ocupem ou tenham ocupado, nos 5 (cinco) anos anteriores, empregos ou funções públicas relevantes, assim como funções relevantes em organizações internacionais.</li>
        <li>Formulário padrão poderá ser solicitado através do e-mail: <a href="mailto:csgservices&#64;aig.com" class="contract-link">csgservices&#64;aig.com</a></li>
      </ol>
    </div>
  </section>

  <!-- Termos e Condições Section -->
  <section class="contract-section">
    <h2 class="section-title">Termos e Condições</h2>
    <div class="section-content">
      <p class="section-text">
        Ao fornecer suas informações pessoais neste formulário, você concorda e confirma, nos termos da Lei 13.709/2019, o seu consentimento para a coleta, tratamento, utilização e compartilhamento de suas informações pessoais pela American International Group, Inc. (AIG), ou qualquer de suas subsidiárias e afiliadas, para seus prestadores de serviços, resseguradores e representantes de seguros que estejam diretamente relacionados à oferta do seu Bilhete de Seguro de Garantia Estendida Reduzida, bem como em caso de regulação de sinistro e também de outra forma estabelecida nas suas políticas de privacidade. Se você incluir informações pessoais de terceiros, você confirma ter autorização e que informou a esta pessoa como a AIG usará essas informações nos termos descritos acima.
      </p>
      <p class="section-text">
        Declara ter ciência de que poderá exercer os seus direitos de confirmação de existência de tratamento; acesso aos dados; correção; anonimização, dentre outros, através do Serviço de Atendimento ao Cliente – Fale com a AIG, incluindo, junto de seu pedido, as seguintes informações: nome completo, tipo e número de documento de identificação, número do bilhete do seguro, telefone para contato, e e-mail.
      </p>
    </div>
  </section>
</div>